module.exports = __webpack_public_path__ + "images/darkIntro.663ac17f.svg";